// extracted by mini-css-extract-plugin
export default {"main":"news_main__9n7os","bigTitle":"news_bigTitle__6gK2J","midTitle":"news_midTitle__dc98C","smallTitle":"news_smallTitle__OKa25","load-more":"news_load-more__SWW6d"};